import { Kind } from './content.js';

const BASE_PARAMS = [
  'allArrivalTimes',
  'allArrivalTimesWeek',
  'allStartTimes',
  'allStartTimesWeek',
  'allStartTimesWithTimezone',
  'allStartTimesWithTimezoneWeek',
  'arrivalTime',
  'bookedAppointments',
  'currentEpoch',
  'location',
  'organizationName',
  'patientFirstName',
  'patientInstructions',
  'patientPreferredFirstName',
  'practiceGroupName',
  'practiceName',
  'practicePhoneNumber',
  'providerFirstName',
  'providerFullName',
  'providerLastName',
  'registrationDatetime',
  'referredByProviderName',
  'referredByProviderPhoneNumber',
  'referredToProviderName',
  'referredToProviderPhoneNumber',
  'specialty',
  'startTime',
  'startTimeWithTimezone',
  'startTimeWithYear',
  'startTimeWithTimezoneWithYear',
  'startTimeDate',
  'startTimeDateWithYear',
  'todayDate',
] as const;

export const EMAIL_PARAMS = [
  ...BASE_PARAMS,
  'allStartTimesWeekWithLocation',
  'allStartTimesWeekWithPractice',
  'allStartTimesWeekWithPracticeAndLocation',
  'appointmentCards',
  'callToActionUrl',
  'encounterVirtualVisitUrl',
  'linkCancelEhrTimeSlotBooking',
  'linkConfirmAppointment',
  'linkMulti',
  'logoImgUrl',
  'notableLogoUrl',
  'recipientEmail',
  'startTimeStr',
  'startTimeInitialStr',
  'startTimeReminderStr',
  'themeButtonBackground',
  'unsubscribeUrl',
  'code', // contact verification
  'digitalCheckInUrl',
] as const;

export const VOICE_PARAMS = [...BASE_PARAMS, 'startTimeRelative', 'startTimeTime'] as const;

export const SMS_PARAMS = [
  ...VOICE_PARAMS,
  'allStartTimesWeekWithLocation',
  'allStartTimesWeekWithPractice',
  'allStartTimesWeekWithPracticeAndLocation',
  'digitalCheckInUrl',
  'encounterVirtualVisitUrl',
  'link',
  'linkConfirmAppointment',
  'linkMulti',
  'virtualVisitUrl',
] as const;

export const INTENT_PARAM = 'intentUrl';

export const PARAMS_BY_KIND: Record<Kind, readonly string[]> = {
  [Kind.Sms]: SMS_PARAMS,
  [Kind.Voice]: VOICE_PARAMS,
  [Kind.Email]: EMAIL_PARAMS,
};
